// contexts/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { authAPI } from '../api/apiClient';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const BASE_URL = 'https://api.transcirox.com/api/admin';

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    if (token) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const adminToken = data.data.access_token;
        setToken(adminToken);
        localStorage.setItem('admin_token', adminToken);
        setCurrentUser(data.data.user);
        return { success: true };
      } else {
        return { success: false, message: data.message || 'Login failed' };
      }
    } catch (error) {
      return { success: false, message: 'Network error' };
    }
  };

  const forgotPassword = async (email) => {
    try {
      const response = await fetch(`${BASE_URL}/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        return { success: true };
      } else {
        return { success: false, message: data.message || 'Login failed' };
      }
    } catch (error) {
      return { success: false, message: 'Network error' };
    }
  };

  const resetPassword = async (token, email, new_password, new_password_confirmation) => {
    try {
      const response = await fetch(`${BASE_URL}/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ token, email, new_password, new_password_confirmation }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const adminToken = data.data.access_token;
        setToken(adminToken);
        localStorage.setItem('admin_token', adminToken);
        setCurrentUser(data.data.user);
        return { success: true };
      } else {
        return { success: false, message: data.message || 'Login failed' };
      }
    } catch (error) {
      return { success: false, message: 'Network error' };
    }
  };

  const checkSuperAdminStatus = async () => {
    try {
      const response = await authAPI.getProfile();
      if (response.success) {
        const userData = response.data.data || response.data;
        setIsSuperAdmin(userData.is_super === 1);
        return userData.is_super === 1;
      }
      return false;
    } catch (error) {
      console.error("Error checking super admin:", error);
      return false;
    }
  };

    const logout = async () => {
    try {
        const response = await fetch(`${BASE_URL}/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        });

        if (response.ok) {
        const data = await response.json();
        toast.success(data.message || 'تم تسجيل الخروج بنجاح', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        } else {
        console.warn('Logout API call failed, but cleaning local data');
        toast.info('تم تسجيل الخروج', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        }
    } catch (error) {
        console.error('Logout error:', error);
        toast.error('حدث خطأ أثناء تسجيل الخروج', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } finally {
        setToken(null);
        setCurrentUser(null);
        localStorage.removeItem('admin_token');
    }
    };


//   const logout = () => {
//     setToken(null);
//     setCurrentUser(null);
//     localStorage.removeItem('token');
//   };

  const value = {
    currentUser,
    token,
    login,
    forgotPassword,
    resetPassword,
    logout,
    checkSuperAdminStatus,
    isSuperAdmin,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}